import React from 'react';
import { createUseStyles } from 'src/theming';

const useStyles = createUseStyles({
  root: {
    fontSize: 16,
  },
});

const AlertTitle: React.FC = ({ children }) => {
  const classes = useStyles();
  return <div className={classes.root}>{children}</div>;
};

export default AlertTitle;
